import React, { useState, useEffect } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axios from 'axios';

const TakeQuiz = () => {
  const [generatedQuestions, setGeneratedQuestions] = useState([]);
  const [userAnswers, setUserAnswers] = useState([]);
  const [correctAnswers, setCorrectAnswers] = useState(0);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [inputError, setInputError] = useState("");
  const navigate = useNavigate();

  let conversationHistory = [];
  const careerGuidancePrompt = `
**Task:** Generate multiple choice questions based on the user-entered topic.
**Topic:** Your goal is to generate five multiple choice questions with one true answer and three false answers. Send the response in the specified format and no extra text.
**Style:** Descriptive
**Tone:** Encouraging
**Audience:** Teenager
**Format:** {
  "mcqs": [
    {
      "question": "",
      "choices": [
        {
          "text": "",
          "isCorrect": true/false
        },
        {
          "text": "",
          "isCorrect": true/false
        },
        {
          "text": "",
          "isCorrect": true/false
        },
        {
          "text": "",
          "isCorrect": true/false
        }
      ]
    }
  ]
}`;


  const generateQuestions = async () => {
    if (input.trim() === "") {
      setInputError("Please enter a topic.");
      return;
    }
    setInputError("");
    setLoading(true);
    setUserAnswers([]);
    setCorrectAnswers(0);
    setCurrentQuestionIndex(0);
    try {
      const hasCareerGuidancePrompt = conversationHistory.some(
        (message) =>
          message.role === "system" && message.content === careerGuidancePrompt
      );

      if (!hasCareerGuidancePrompt) {
        conversationHistory.push({
          role: "system",
          content: careerGuidancePrompt,
        });
      }

      conversationHistory.push({ role: "user", content: input });
      setInput("");
      const response = await axios.post(`/quiz/quiz/generate`, {
        conversationHistory,
      });

      console.log(response.data.reply);

      const assistantResponse = JSON.parse(
        response.data.reply
      );
      setGeneratedQuestions(assistantResponse.mcqs);
      setCurrentQuestionIndex(0);
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const handleChoiceSelect = (questionIndex, choiceIndex, selected) => {
    const updatedUserAnswers = [...userAnswers];
    if (selected) {
      updatedUserAnswers[questionIndex] = choiceIndex;
    } else {
      updatedUserAnswers[questionIndex] = undefined;
    }

    setUserAnswers(updatedUserAnswers);
  };

  const handleNextQuestion = () => {
    setCurrentQuestionIndex(currentQuestionIndex + 1);
  };

  const handlePreviousQuestion = () => {
    setCurrentQuestionIndex(currentQuestionIndex - 1);
  };

  useEffect(() => {
    const newCorrectAnswers = generatedQuestions.reduce(
      (count, question, index) => {
        if (userAnswers[index] !== undefined) {
          if (question.choices[userAnswers[index]].isCorrect) {
            return count + 1;
          }
        }
        return count;
      },
      0
    );

    setCorrectAnswers(newCorrectAnswers);
  }, [generatedQuestions, userAnswers]);

  const handleInput = (e) => {
    const newValue = e.target.value;
    setInput(newValue);
    if (newValue.trim() !== "") {
      setInputError("");
    }
  };

  return (
    <div className="container mb-10" style={{ minHeight: "80vh" }}>
      <div className="text-center mt-3 mb-5">
        <h4>Enter Topic</h4>
        <Form className="w-25 p-3 d-inline-block">
          <Form.Group controlId="topicInput">
            <Form.Control
              type="text"
              placeholder="Enter a topic"
              value={input}
              onChange={handleInput}
              isInvalid={!!inputError}
            />
            <Form.Control.Feedback type="invalid">
              {inputError}
            </Form.Control.Feedback>
          </Form.Group>
          {loading ? (
            <Spinner style={{ marginTop: 10 }} animation="border" role="status">
              <span className="sr-only"></span>
            </Spinner>
          ) : (
            <Button
              className="mt-2"
              variant="outline-primary"
              onClick={generateQuestions}
              disabled={!input.trim()}
            >
              Generate Quiz
            </Button>
          )}
        </Form>
      </div>
      {generatedQuestions.length > 0 && (
        <div>
          <h6>{generatedQuestions[currentQuestionIndex].question}</h6>
          <Form>
            {generatedQuestions[currentQuestionIndex].choices.map(
              (choice, choiceIndex) => (
                <Form.Check
                  key={choiceIndex}
                  type="radio"
                  label={choice.text}
                  checked={userAnswers[currentQuestionIndex] === choiceIndex}
                  isCorrect={choice.isCorrect ? "(Correct)" : ""}
                  onChange={(e) =>
                    handleChoiceSelect(
                      currentQuestionIndex,
                      choiceIndex,
                      e.target.checked
                    )
                  }
                />
              )
            )}
          </Form>

          <div className="text-center mt-3 ">
            <Button
              variant="outline-primary"
              onClick={handlePreviousQuestion}
              disabled={currentQuestionIndex === 0}
              className="text-center"
              style={{ marginBottom: "20px", marginRight: "5px" }}
            >
              Previous
            </Button>
            <Button
              style={{ marginBottom: "20px", marginLeft: "5px" }}
              variant="outline-primary"
              onClick={handleNextQuestion}
              disabled={currentQuestionIndex === generatedQuestions.length - 1}
            >
              Next
            </Button>
          </div>
        </div>
      )}

      {generatedQuestions.length > 0 && userAnswers.length === 5 && (
        <div className="text-center mt-3" style={{ marginBottom: "20px" }}>
          <Button
            type="button"
            className="btn btn-primary"
            onClick={() =>
              navigate("/quiz-app/feedback", {
                state: {
                  generatedQuestions: generatedQuestions,
                  userAnswers: userAnswers,
                  correctAnswers: correctAnswers,
                },
              })
            }
          >
            Submit
          </Button>
        </div>
      )}
    </div>
  );
};

export default TakeQuiz;
